module.exports = "/images/gmail.png?45f297c93b598911360acbbad80bf25f";